import { h } from 'preact';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';

const drawerWidth = 360;

export default function LazyEditorV2Sidebar(_props) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          zIndex: 1000,
          backgroundColor: '#fff',
          boxSizing: 'border-box',
        },
      }}
    >
      <Toolbar />

      <Box sx={{ overflow: 'auto' }}>
        <Paper
          elevation={2}
          sx={{
            px: 1,
            py: 2,
            position: 'sticky',
            top: '0px',
            width: '100%',
            backgroundColor: '#fff',
            zIndex: 1500,
          }}
        >
          <Skeleton height={42} width={'100%'} />
        </Paper>

        <Box sx={{ px: 3, py: 2 }}>
          <FormControl component="fieldset" variant="standard">
            <FormGroup>
              <FormControlLabel
                control={<Skeleton height={38} width={58} />}
                label="Enabled"
              />
            </FormGroup>
          </FormControl>

          <Divider sx={{ my: 2 }} />

          <InputLabel id="method-label" sx={{ my: 2 }}>
            Method
          </InputLabel>

          <FormControl fullWidth>
            <InputLabel></InputLabel>
            <Skeleton height={56} width={'100%'} />
          </FormControl>

          <Divider sx={{ my: 2 }} />

          <Skeleton height={56} width={'100%'} />
          <Skeleton height={40} width={'100%'} />

          <Divider sx={{ my: 2 }} />

          <List
            subheader={
              <ListSubheader sx={{ px: 0 }}>Input Schemas</ListSubheader>
            }
          >
            <ListItem disablePadding>
              <ListItemButton dense selected={true}>
                <ListItemText primary={<Skeleton width={'100%'} />} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton dense>
                <ListItemText primary={<Skeleton width={'100%'} />} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton dense>
                <ListItemText primary={<Skeleton width={'100%'} />} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton dense>
                <ListItemText primary={<Skeleton width={'100%'} />} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton dense>
                <ListItemText primary={<Skeleton width={'100%'} />} />
              </ListItemButton>
            </ListItem>
          </List>

          <Typography variant="caption">
            Schema documentation{' '}
            <a
              href="https://www.rfc-editor.org/rfc/rfc8927.html"
              target="_blank"
              rel="noopener noreferer"
            >
              here
            </a>
            . Mind that an empty schema means no input!
          </Typography>
          <Divider sx={{ my: 2 }} />

          <InputLabel id="method-label" sx={{ my: 2 }}>
            Allowed origins
          </InputLabel>

          <Skeleton height={54} width={'100%'} />

          <Divider sx={{ my: 2 }} />
        </Box>
      </Box>
    </Drawer>
  );
}
